module.exports = __webpack_public_path__ + "static/alpescraft-96e93ef0f18588a6dc0e08f378af9af2.png";